import FaceMachineUpgradeBlock from './FaceMachineUpgradeBlock';

export default FaceMachineUpgradeBlock;
